module.exports = __webpack_public_path__ + "static/img/valueadd18.86c8c1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/valueadd18.png
// module id = A+nT
// module chunks = 1